import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'
import '../styles/index.scss'
import '@/assets/iconfont/iconfont.css'
import methods from '@/utils/methods'
import { getUserInfo } from '@/api/user'
import { removeCodeFromUrl } from '@/utils/utils'

Vue.prototype.$appLogined = new Promise(resolve => (Vue.prototype.$appLoginedIsResolve = resolve))

import wx from '@/plugins/wx'
Vue.use(wx)
Vue.use(methods)

Vue.config.productionTip = false

// 从localStorage获取登录信息
const tokenValue = localStorage.getItem('user_tokenValue')
store.dispatch('login/set_token_value', tokenValue || '')

// 如果有token，尝试获取最新的用户信息
if (tokenValue) {
  // 使用store中的fetchUserInfo action替代直接调用getUserInfo
  store.dispatch('login/fetchUserInfo')
    .then(userInfo => {
      if (userInfo) {
        // 获取用户信息成功后，清理URL中的code参数
        removeCodeFromUrl()
        Vue.prototype.$appLoginedIsResolve()
      }
    })
    .catch(() => {
      // token可能已过期，清除登录状态
      localStorage.removeItem('user_tokenValue')
      store.dispatch('login/set_token_value', '')
      store.dispatch('login/set_user_info', null)
    })
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
